export default __webpack_public_path__ + "static/media/FloorMMintTowerBuildingMain.6f9e1ac2.svg";